import { useAppStore } from '@/hud-bridge/store'

export function ModeSelectScreen() {
  const mode = useAppStore((s) => s.mode)
  const setMode = useAppStore((s) => s.setMode)
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div className="screen">
      <div className="menu-enter" style={{ marginTop: '10vh', maxWidth: 520 }}>
        <h1 className="h1">Режим</h1>
        <p className="muted">Один выбор win-condition на партию.</p>

        <div className="segmented" style={{ marginTop: 20 }} role="group" aria-label="Режим игры">
          <button
            type="button"
            className={mode === 'exit' ? 'active' : ''}
            onClick={() => setMode('exit')}
          >
            Exit
          </button>
          <button
            type="button"
            className={mode === 'clear' ? 'active' : ''}
            onClick={() => setMode('clear')}
          >
            Clear
          </button>
        </div>

        <p className="muted" style={{ marginTop: 16 }}>
          {mode === 'exit'
            ? 'Дойти до выхода живым. Полная очистка не обязательна.'
            : 'Обезвредить все мины (hold Defuse). Выход на карте неактивен.'}
        </p>

        <div className="btn-row">
          <button type="button" className="btn btn-primary" onClick={() => setScreen('map')}>
            Далее
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('menu')}>
            Назад
          </button>
        </div>
      </div>
    </div>
  )
}
